import { render, staticRenderFns } from "./autosdetail.vue?vue&type=template&id=c42e062c"
import script from "./autosdetail.vue?vue&type=script&lang=js"
export * from "./autosdetail.vue?vue&type=script&lang=js"
import style0 from "./autosdetail.vue?vue&type=style&index=0&id=c42e062c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports